const MAX_UPLOAD_FILE_SIZE = 8000000;

export { MAX_UPLOAD_FILE_SIZE as default, MAX_UPLOAD_FILE_SIZE };
